import { Component, OnInit } from "@angular/core";
import { Address } from "../../forms/address-form/address-form.component";
import { EncomendaService } from "../../services/ajs-encomenda.service";
import { PedidoService } from "../../services/ajs-pedido.service";
import { UiRouterState } from "../../services/ajs-router-state.service";

@Component({
  selector: "mandae-package-create",
  templateUrl: "./package-create.component.html",
  styleUrls: ["./package-create.component.scss"],
})
export class PackageCreateComponent {
  public error: any = null;

  constructor(
    private pedidoService: PedidoService,
    private encomendaService: EncomendaService,
    private router: UiRouterState
  ) {}

  public async handlePackageComplete(data: any) {
    const order = this.pedidoService.getPedido();

    const packageData = this.mapPackageData(data);
    console.log("pack", packageData);

    try {
      const createdPackage = await this.encomendaService.criar(
        order,
        packageData
      );
      order.remessas.push(createdPackage);
      this.pedidoService.setPedido(order);

      this.router.go("pedido.encomendas");
    } catch (e) {
      this.error = e;
    }
  }

  private mapAddress(address: Address) {
    return {
      cep: address.postalCode.replace(/\D/g, ""),
      logradouro: address.street,
      numero: address.number,
      bairro: address.district,
      cidade: address.city,
      uf: address.state,
      referencia: address.observation,
      complemento: address.complement,
    };
  }

  private mapRecipient(data: any) {
    // Sanitização preserva letras: o CNPJ pode ser alfanumérico (IN RFB nº 2.229/2024)
    // a partir de julho/2026, então só removemos os separadores da máscara.
    const document = (data.document || "")
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "");
    const isCpf = document.length === 11;
    const personType = isCpf ? "fisica" : "juridica";

    return {
      tipoPessoa: personType,
      cpf: isCpf ? document : null,
      cnpj: !isCpf ? document : null,
      inscricaoEstadual:
        !isCpf && data.stateDocument
          ? data.stateDocument
          : null,
      email: data.email || null,
      telefone: data.phone.replace(/\D/g, "") || null,
      nome: data.name || null,
    };
  }

  private mapPackageData(data: any) {
    console.log("data", data);
    return {
      destinatario: {
        endereco: this.mapAddress(data.address),
        ...this.mapRecipient(data.packageData),
      },
      chaveAcessoNFe: data.packageData.NFe || null,
      servicoEnvio: data.shippingService.codigo,
      prazoMaximo: data.shippingService.prazoMaximo,
      prazoMinimo: data.shippingService.prazoMinimo,
      valorDeclarado: data.packageData.insurance
        ? +data.packageData.insuredValue
            .replace(/[^0-9,]/g, "")
            .replace(",", ".")
            .replace(/\.$/, "")
        : null,
      referencia: data.packageData.reference || null,
      observacao: data.packageData.observation || null,
      tipoDocumentoOrigem: data.typeDocument,
      mandaeEscolhe: true,
      quantidadeVolumes: data.packageData.quantidadeVolumes,
    };
  }
}
